import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    showFooter: false, // 默认显示footer
  }),
})
